import React, { useState, useEffect } from "react";
import "react-multi-carousel/lib/styles.css";
import BoatHelm from "../../../../../../Asset/icon/boat_helm.svg";
import TopDestinationMultiRow from "../../../../../../components/multiRow/TopDestinationMultiRow";
import AllHeader from "../../../../../../components/Navbar/AllHeader";
import IslandCard from "../../../../../../components/card/IslandCard";
import YachtCard from "../../../../../../components/card/YachtCard";
import Footer from "../../../../../../components/footerPage/Footer";
import { useParams } from "react-router-dom";
import { Link } from "react-router-dom";
import BestSeller from "../../../../homePages/components/BestSeller";
import { useSelector, useDispatch } from "react-redux";
import { getYachtInformationDetail } from "../../../../../../redux/yachtInformation/YachtInformationSlice";
import { getYachtInfoSellingPriceRatePlanListDetail } from "../../../../../../redux/YachtInfoSellingPriceRatePlanList/YachtInfoSellingPriceRatePlanListSlice";
import { getYachtInfoDestinationPackageDetail } from "../../../../../../redux/yachtInfoDestinationPackage/YachtInfoDestinationPackageSlice";
import { getYachtDetail } from "../../../../../../redux/yacht/YachtSlice";
import { getYachtInfoAmenitiesDetail } from "../../../../../../redux/YachtInfoAmenities/YachtInfoAmenitiesSlice";
import { getYachtInfoWaterToyDetail } from "../../../../../../redux/YachtInfoWaterToy/YachtInfoWaterToySlice";
import {
  getCountryDetail,
  getProvinceDetail,
  getMarinaDetail,
  getDestinationDetail,
} from "../../../../../../redux/centerData/CenterDataSlice";
import { useTranslation } from "react-i18next";
import "../../../../../../Asset/scss/takemyyacht.scss";
import Sail from "../../../../../../Asset/image/yacht/Sail.gif";
import SEO from "../../../../../../components/SEO/SEO";

function DetailIsland() {
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("selectedLanguage");

  const yachtCardContainer = {
    boxShadow: "0px 0px 5px 2px rgba(0, 0, 0, 0.2)",
  };
  const { slug } = useParams();
  const todos = useSelector((state) => state);
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([
      dispatch(getDestinationDetail({})),
      dispatch(getProvinceDetail({})),
      dispatch(getMarinaDetail({})),
      dispatch(getCountryDetail({})),
      dispatch(getYachtInformationDetail({})),
      dispatch(getYachtInfoSellingPriceRatePlanListDetail({})),
      dispatch(getYachtInfoDestinationPackageDetail({})),
      dispatch(getYachtDetail({})),
      dispatch(getYachtInfoAmenitiesDetail({})),
      dispatch(getYachtInfoWaterToyDetail({})),
    ])
      .then(() => {
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [dispatch]);

  const [showScrollTop, setShowScrollTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setShowScrollTop(window.scrollY > 300);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // ค้นหา destination ที่ตรงกับ `slug` จาก Redux store
  const selectedDestination = loading
    ? null
    : todos.CenterDataSlice.Destination.results.find(
        (Destination) => Destination.name_destination_en === slug,
      );

  // ค้นหา province ของ destination ที่เลือก
  const selectedProvinceDestination = loading
    ? null
    : todos.CenterDataSlice.Province.results.find(
        (province) => province.ProvinceID === selectedDestination?.id_province,
      );

  // ดึงข้อมูลประเทศที่ตรงกับ "Thailand"
  const country =
    todos.CenterDataSlice.Country.results &&
    todos.CenterDataSlice.Country.results.find(
      (e) => e.country_name === "Thailand",
    );

  // ค้นหา yacht ที่ถูกใช้งานใน TMY website เท่านั้น
  const today = new Date();

  const selectedYacht = loading
    ? null
    : todos.YachtInfoSellingPriceRatePlanListSlice.YachtInfoSellingPriceRatePlanList.results.filter(
        (yacht) => {
          // ✅ แปลงวันที่จาก VARCHAR ("2025/10/16") → Date
          const startDate = yacht.start_rate_plan_date
            ? new Date(yacht.start_rate_plan_date.replace(/\//g, "-"))
            : null;
          const endDate = yacht.end_rate_plan_date
            ? new Date(yacht.end_rate_plan_date.replace(/\//g, "-"))
            : null;

          // ✅ เช็คว่าปัจจุบันอยู่ในช่วงวันที่ rate plan ใช้งานได้
          const isWithinDateRange =
            (!startDate || today >= startDate) &&
            (!endDate || today <= endDate);

          // ✅ เงื่อนไขหลัก
          return (
            yacht.rate_plan_use_in_TMY_web_site === 1 && isWithinDateRange // เพิ่มตรงนี้
          );
        },
      );

  // รวมข้อมูล yacht, marina และ province เพื่อใช้ในแสดงผล
  const selectedYachtWithMarinaAndProvince = loading
    ? []
    : (() => {
        const selectedYachtWithAdditionalInfo = selectedYacht.map((yacht) => ({
          ...yacht,

          // หาชื่อ Marina ที่ตรงกับ `id_marina`
          name_marina_en: todos.CenterDataSlice.Marina.results.find(
            (marina) => marina.id_marina === yacht.id_marina,
          )?.name_marina_en,

          name_marina_th: todos.CenterDataSlice.Marina.results.find(
            (marina) => marina.id_marina === yacht.id_marina,
          )?.name_marina_th,

          // หาชื่อ Province ที่เชื่อมโยงกับ marina
          ProvinceEng: todos.CenterDataSlice.Province.results.find(
            (province) =>
              province.ProvinceID ===
              todos.CenterDataSlice.Marina.results.find(
                (marina) => marina.id_marina === yacht.id_marina,
              )?.id_province,
          )?.ProvinceEng,

          ProvinceThai: todos.CenterDataSlice.Province.results.find(
            (province) =>
              province.ProvinceID ===
              todos.CenterDataSlice.Marina.results.find(
                (marina) => marina.id_marina === yacht.id_marina,
              )?.id_province,
          )?.ProvinceThai,

          // หารายการ destination ที่ yacht package ครอบคลุม
          destinationIds:
            todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
              (desID) =>
                desID.id_destination_package === yacht.id_destination_package,
            )?.destination_included,

          // ค้นหาและรวมชื่อ destination ภาษาอังกฤษ
          DestinationEng: (() => {
            const destinationIds =
              todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
                (desID) =>
                  desID.id_destination_package === yacht.id_destination_package,
              )?.destination_included;

            const destinationIdsArray = destinationIds
              ? destinationIds.split(",")
              : [];
            const destinationNames = destinationIdsArray.map(
              (destinationId) => {
                const destination =
                  todos.CenterDataSlice.Destination.results.find(
                    (destination) =>
                      destination.id_destination === destinationId,
                  );
                return destination ? destination.name_destination_en : null;
              },
            );

            return destinationNames.join(",");
          })(),

          // ค้นหาและรวมชื่อ destination ภาษาไทย
          DestinationThai: (() => {
            const destinationIds =
              todos.YachtInfoDestinationPackageSlice.YachtInfoDestinationPackage.results.find(
                (desID) =>
                  desID.id_destination_package === yacht.id_destination_package,
              )?.destination_included;

            const destinationIdsArray = destinationIds
              ? destinationIds.split(",")
              : [];
            const destinationNames = destinationIdsArray.map(
              (destinationId) => {
                const destination =
                  todos.CenterDataSlice.Destination.results.find(
                    (destination) =>
                      destination.id_destination === destinationId,
                  );
                return destination ? destination.name_destination_th : null;
              },
            );

            return destinationNames.join(",");
          })(),

          // ค้นหา travel agent ของ yacht
          travelAgent: todos.YachtSlice.Yacht.results.find(
            (travelAgent) => travelAgent.id_yacht === yacht.id_yacht,
          )?.name_yacht,

          vat: todos.YachtSlice.Yacht?.results.find(
            (y) => y.id_yacht === yacht.id_yacht,
          ),

          // ค้นหารายการ amenities ของ yacht
          YachtInfoAmenities:
            todos.YachtInfoAmenitiesSlice.YachtInfoAmenities.results.filter(
              (yachtInfoAmenities) =>
                yachtInfoAmenities.id_yachtInfo === yacht.id_yachtInfo,
            ),

          // ค้นหารายการ water toy ของ yacht
          YachtInfoWaterToy:
            todos.YachtInfoWaterToySlice.YachtInfoWaterToy.results.filter(
              (yachtInfoWaterToy) =>
                yachtInfoWaterToy.id_yachtInfo === yacht.id_yachtInfo,
            ),
        }));

        // กรองเฉพาะ yacht ที่มี destination ตรงกับ `slug`
        return selectedYachtWithAdditionalInfo.filter(
          (yacht) =>
            yacht.DestinationEng && yacht.DestinationEng.includes(slug),
        );
      })();

  // ใช้ Set เก็บ travel agent เพื่อนับจำนวนแบบไม่ซ้ำกัน
  const uniqueTravelAgents = new Set();

  selectedYachtWithMarinaAndProvince.forEach((yacht) => {
    if (yacht.travelAgent) {
      uniqueTravelAgents.add(yacht.travelAgent);
    }
  });

  const numberOfTravelAgents = uniqueTravelAgents.size; // นับจำนวน travel agents ที่ไม่ซ้ำกัน
  const numberOfYachts = selectedYachtWithMarinaAndProvince.length; // นับจำนวน yacht ทั้งหมดที่พบ

  return (
    <>
      {!loading && selectedDestination && (
        <SEO
          title={
            selectedLanguage === "en"
              ? `${selectedDestination.name_destination_en} | Take My Yacht`
              : `${selectedDestination.name_destination_th} | Take My Yacht`
          }
          description={
            selectedLanguage === "en"
              ? selectedDestination.description_en
              : selectedDestination.description_th
          }
          url={`https://takemyyacht.com/destination/detailIsland/${slug}`}
          image={selectedDestination.destination_img}
          schema={{
            "@context": "https://schema.org",
            "@type": "TouristDestination",
            name:
              selectedLanguage === "en"
                ? selectedDestination.name_destination_en
                : selectedDestination.name_destination_th,
            description:
              selectedLanguage === "en"
                ? selectedDestination.description_en
                : selectedDestination.description_th,
            touristType: "Yacht Charter",
            address: {
              "@type": "PostalAddress",
              addressCountry: "TH",
            },
          }}
        />
      )}

      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 9999,
          }}
        >
          <img
            src={Sail}
            alt="Loading..."
            style={{
              width: 300,
              height: 300,
              objectFit: "contain",
              borderRadius: "12px",
            }}
            draggable={false}
          />
        </div>
      )}

      <div>
        <AllHeader />
        <div className="container" style={{ marginTop: "5vh" }}>
          <div className="row align-items-stretch">
            <div className="col-lg-1 order-md-1 d-none d-lg-block"></div>
            <div className="col-lg-4 text-center order-md-2 col-md-12 mb-4">
              <TopDestinationMultiRow />
            </div>
            <div className="col-lg-1 order-md-2 d-none d-lg-block"></div>
            <div className="col-lg-5 text-center order-md-2 col-md-12 mb-4">
              <div className="mb-4">
                <img
                  className="BoatHelm-1"
                  draggable={false}
                  src={BoatHelm}
                  alt="BoatHelm"
                />
                <h2>{t("Destination")}</h2>
              </div>

              {!loading ? (
                <div className="ProvinceCard">
                  {selectedDestination && selectedProvinceDestination && (
                    <div>
                      <IslandCard
                        Image={selectedDestination.destination_img}
                        name={
                          selectedLanguage === "en"
                            ? selectedDestination.name_destination_en
                            : selectedDestination.name_destination_th
                        }
                        provinceName={
                          selectedLanguage === "en"
                            ? selectedProvinceDestination.ProvinceEng
                            : selectedProvinceDestination.ProvinceThai
                        }
                        provinceCountry={country?.country_name}
                        description={
                          selectedLanguage === "en"
                            ? selectedDestination.description_en
                            : selectedDestination.description_th
                        }
                        agentLenght={numberOfTravelAgents}
                        yachtLenght={numberOfYachts}
                      />
                    </div>
                  )}
                </div>
              ) : null}

              <div className="mb-4">
                <img
                  className="BoatHelm-1"
                  draggable={false}
                  src={BoatHelm}
                  alt="BoatHelm"
                />
                <h2>{t("Yacht lists")}</h2>
              </div>

              {!loading ? (
                <div>
                  {selectedYachtWithMarinaAndProvince &&
                  selectedYachtWithMarinaAndProvince.length > 0 ? (
                    selectedYachtWithMarinaAndProvince.map(
                      (yachtInfo, index) => {
                        return (
                          <Link
                            key={index}
                            to={`/yacht/detailYacht/${yachtInfo.id_sellingPrice}`}
                          >
                            <YachtCard
                              headline={yachtInfo.name_yacht_yachtInfo}
                              image={yachtInfo.logo_yachtInfo_url}
                              marina={
                                selectedLanguage === "en"
                                  ? yachtInfo.name_marina_en
                                  : yachtInfo.name_marina_th
                              }
                              province={
                                selectedLanguage === "en"
                                  ? yachtInfo.ProvinceEng
                                  : yachtInfo.ProvinceThai
                              }
                              travelAgent={yachtInfo.travelAgent}
                              vat={yachtInfo.vat.vat}
                              travelNO={yachtInfo.vat.travel_agent_no}
                              dayOption={yachtInfo.rate_type}
                              amenities={yachtInfo.YachtInfoAmenities}
                              waterToy={yachtInfo.YachtInfoWaterToy}
                              price={yachtInfo.value_sellingPrice}
                              style={yachtCardContainer}
                              cruising_speed={yachtInfo.cruising_speed}
                              guests_day={yachtInfo.guests_day}
                              guests_sleeping={yachtInfo.guests_sleeping}
                            />
                          </Link>
                        );
                      },
                    )
                  ) : (
                    <div>{t("No yachts available")}</div>
                  )}
                </div>
              ) : null}
            </div>

            <div className="col-lg-1 order-md-3 d-none d-lg-block"></div>
            <div className="col-lg-12 text-center order-md-3 col-md-12 mb-4">
              <BestSeller />
            </div>
          </div>
        </div>
        <Footer />
      </div>

      {showScrollTop && (
        <button
          onClick={scrollToTop}
          aria-label="Scroll to top"
          style={{
            position: "fixed",
            bottom: "24px",
            right: "24px",
            width: "50px",
            height: "50px",
            borderRadius: "50%",
            border: "none",
            backgroundColor: "#3291B6", // สีเดิม
            color: "#fff",
            cursor: "pointer",
            boxShadow: "0 10px 25px rgba(0,0,0,0.25)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            transition: "all 0.25s ease",
          }}
          onMouseEnter={(e) => {
            e.currentTarget.style.transform = "translateY(-4px)";
          }}
          onMouseLeave={(e) => {
            e.currentTarget.style.transform = "translateY(0)";
          }}
        >
          {/* Chevron Up */}
          <svg
            width="26"
            height="26"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="18 15 12 9 6 15" />
          </svg>
        </button>
      )}
    </>
  );
}

export default DetailIsland;
